import { render, staticRenderFns } from "./postProps.vue?vue&type=template&id=b9a38c9a&"
import script from "./postProps.vue?vue&type=script&lang=js&"
export * from "./postProps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports